import React from "react";
import "./App.css";
import getAccountData from "./getAccountData";
import DoctorInfo from "./components/DoctorInfo";
import Header from "./components/Header";
import Player from "./components/Player";
import querystring from "querystring";
import ReactGA from "react-ga";

class App extends React.Component {
  constructor(props) {
    super(props);

    // Google Analytics
    if (window.location.hostname !== "localhost") {
      ReactGA.initialize("UA-3946480-55");
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }

  state = { accountData: null };

  async componentDidMount() {
    const { accountCode } = this.props.match.params;

    try {
      // Get account data.
      const accountData = await getAccountData(accountCode);

      // Grab query string data.
      const params = querystring.parse(this.props.location.search);
      const playerLink = params["?link"];

      if (playerLink) {
        this.setState({ playerLink, accountData });
      }
    } catch (error) {}
  }

  render() {
    const { accountData, playerLink } = this.state;

    if (accountData && playerLink) {
      const {
        Color,
        LogoUrl,
        Name,
        PhotoUrl,
        WebsiteUrl
      } = accountData.Account;

      return (
        <div
          id="ucom-share-wrapper"
          style={{ backgroundColor: Color ? "#" + Color : "#FFF" }}
        >
          <div className="content">
            {/* Header */}
            {LogoUrl && <Header websiteUrl={WebsiteUrl} logoUrl={LogoUrl} />}

            {/* Player */}
            <Player playerLink={playerLink} />

            {/* Doctor Section */}
            <DoctorInfo
              name={Name}
              photoUrl={PhotoUrl}
              websiteUrl={WebsiteUrl}
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default App;
